// import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'

export const rtfToHtml = (doc: any): string => {
  const html = documentToHtmlString(doc)
  return `${html}`
}
